/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ideal_Swift_Polecat_FileInputs */

const fr_ideal_swift_polecat_file = /** @type {(inputs: Ideal_Swift_Polecat_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des meilleurs records personnels pour cet exercice.`)
};

/**

* @param {Ideal_Swift_Polecat_FileInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ideal_swift_polecat_file = /** @type {((inputs?: Ideal_Swift_Polecat_FileInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ideal_Swift_Polecat_FileInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ideal_swift_polecat_file(inputs)
});